import type { LayoutProps, PageProps } from '@/types'

import getPublicUrl from '@/helpers/utils/routing/getPublicUrl'
import { toPathFactory } from '@/helpers/utils/routing/toPathFactories'
import type { DonationFormSearchParams } from '@/donationPages/_dependencies/operations/getDonationFormConfig'

export const pageUrl = '/[locale]/donate/iframe/[receiver-type]/[slug]'
export const getPageUrl = toPathFactory(pageUrl, getPublicUrl)
export type IFrameDonationPageProps = PageProps<typeof pageUrl, DonationFormSearchParams>
export type IFrameDonationLayoutProps = LayoutProps<typeof pageUrl>
